import { render, staticRenderFns } from "./DifficultyLevel.vue?vue&type=template&id=175bf06a&scoped=true&"
import script from "./DifficultyLevel.vue?vue&type=script&lang=js&"
export * from "./DifficultyLevel.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyLevel.vue?vue&type=style&index=0&id=175bf06a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bf06a",
  null
  
)

export default component.exports